"use client";

import React from "react";
import { AuthProvider } from "react-oidc-context";

export function OidcAuthProvider({ children, oidcConfig }) {
    return <AuthProvider {...oidcConfig}>{children}</AuthProvider>;
}
